import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
// The Bootstrap re-skin, and it must be imported HERE - immediately after bootstrap.css and
// before every app stylesheet. Almost every rule in it is (0,1,0), exactly Bootstrap's own
// weight, so source order is the only tie-breaker: from this slot it beats Bootstrap and loses
// to the app, which is what keeps the eyebrow strip, .shell-breadcrumb and the active-tab marker
// winning exactly as they do today. src/theme.css is the opposite case and is @import-ed at the
// top of src/index.css instead. tools/css/checkOrder.py asserts both positions.
import './bootstrap.theme.css';
import 'react-tagsinput/react-tagsinput.css';
import { GoogleOAuthProvider } from "@react-oauth/google"
import App from './pages/App/index.js';
import Config from "context/config";
import Theme from "context/theme";
import { installDeferredResizeObserver } from "context/resizeObserver";
import * as serviceWorker from './serviceWorker';
import version from './version';
import './index.css';

// Before anything renders: every resize callback lands on the next frame, so a library observer
// that changes layout inside its own delivery cannot close the loop the browser reports as
// "ResizeObserver loop completed with undelivered notifications" — see context/resizeObserver.js.
installDeferredResizeObserver();

// The theme attribute is already on <html> — the inline script in public/index.html stamped it
// during head parsing, which is what makes the FIRST paint correct. This attaches the two things
// that script cannot, because it has already finished running: the live OS switch while the app is
// open, and cross-tab sync. It re-stamps as well, so the app is still correct if that script is ever
// absent. Must run before createRoot so no component constructs against an unstamped root.
Theme.install();

// Lets the deployed bundle report which build it is; delete this and the version becomes
// unreachable, because src/version.js is otherwise imported nowhere and webpack tree-shakes it out.
window.__BLOBHUB_VERSION__ = version;

// Initialize application
ReactDOM.createRoot(document.getElementById("root")).render(
  <GoogleOAuthProvider clientId={Config.authGoogleClientId()}>
    <App />
  </GoogleOAuthProvider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
